module.exports = {
  Visor3D: {
    Auto_rotate: "Döndür",
    Allow_fullscreen: "Tam ekrana izin ver",
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    color: "Renk",
    opacity: "Opaklık",
    padding: "Alan",
    PluginName: "Visor 3D",
    radius: "Radyan",
    // "Scroll": "Kaydır",
    settings: "Ayarlar",
    source: "Kaynak",
    style: "Plugin Stil",
    URL: "URL",
  },
};
